import React from 'react';

import { useRecoilState } from 'recoil';

import { loginModalState } from 'components/state';

import LoginCard from './components/LoginCard';
import LoginModal from './components/LoginModal/LoginModal';

// Self-contained login slot for wizard sidebars. Consumes the global
// loginModalState atom directly so any feature (self-scheduling, Venis, …)
// can drop it in with optional login params/callbacks.
const LoginSlot = ({ extraLoginParams, onPostLogin } = {}) => {
  const [{ isOpen }, setLoginModal] = useRecoilState(loginModalState);
  const open = () => setLoginModal({ isOpen: true });
  const close = () => setLoginModal({ isOpen: false });

  return (
    <>
      <LoginCard onOpenLoginModal={open} />
      <LoginModal
        isOpen={isOpen}
        handleClose={close}
        extraLoginParams={extraLoginParams}
        onPostLogin={onPostLogin}
      />
    </>
  );
};

export default LoginSlot;
